import { Component, Input, OnInit } from '@angular/core';
import { AiSourcingService } from 'src/app/_services/ai-sourcing.service';
import * as _ from 'underscore';
import moment from 'moment';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { AiSourcingHandlerService } from 'src/app/_services/ai-sourcing-handler.service';

@Component({
    selector: 'app-ai-sourcing-activity',
    templateUrl: './ai-sourcing-activity.component.html',
    styleUrls: ['./ai-sourcing-activity.component.scss'],
    standalone: false
})
export class AiSourcingActivityComponent implements OnInit {

  projectNumber: string;
  allActivity: any[] = [];
  groupedActivityList: any[] = [];

  userDetails: any;
  projectDetails: any;
  blur: boolean = false;

  constructor(
    private aiSourcingService: AiSourcingService,
    private localstorageservice: LocalStorageService,
    private aiSourcingHandlerService: AiSourcingHandlerService
  ) { }

  ngOnInit() {

    setTimeout(() => {
      const filterRow = document.querySelector<HTMLElement>("#topActivity");
      if (filterRow) {
        const y = filterRow.getBoundingClientRect().top + window.scrollY - 200;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }, 0);

    this.projectNumber = window.location.pathname?.split('/')[3];
    this.userDetails = this.localstorageservice.getItem('userdata');
    this.projectDetails = this.aiSourcingHandlerService.fetchProjectDetails;

    this.getprojectActivity()

  }

  getprojectActivity() {

    this.aiSourcingService.getprojectActivity(this.projectNumber).subscribe((res: any) => {

      if (res.status === 'success') {
        this.allActivity = res?.data;
        this.groupActivityByDate();
      } else {
        this.allActivity = [];
      }
       if(this.projectDetails?.status === 'inactive') {
              this.blur = true;
                document.body.classList.add('no-scroll');


    }
    })
  };

  /**
   * Method to format activity with date groupby
   */
  groupActivityByDate(): void {
    const formatted: any[] = [];

    for (let i = 0; i < this.allActivity.length; i++) {
      const item = this.allActivity[i];
      let actionText = '';

      if (item.actiontype === 'criteria-suggestions-added' && (item.action === 'update' || item.action === 'clone')) {
        actionText = `has ${item.action === 'clone' ? 'cloned' : 'launched'} a project called ${this.projectDetails.projectname}.`
      } else if (item.actiontype === 'update_candidate_status_bulk' && item.action === 'update' && item.newvalue === 'shortlisted') {
        actionText = `has shortlisted ${item.additionaldata} candidate${item.additionaldata > 1 ? `'s` : ''} to ${this.projectDetails.projectname}`;
      } else if (item.actiontype === 'update_candidate_status_bulk' && item.action === 'update' && item.newvalue === 'archive') {
        actionText = `has archived ${item.additionaldata} candidate${item.additionaldata > 1 ? `'s` : ''} to ${this.projectDetails.projectname}`;
      }  else if (item.actiontype === 'add_to_email_campaign_bulk' && item.action === 'tagged') {
        actionText = `has tagged ${item.additionaldata} candidate${item.additionaldata > 1 ? `'s` : ''} to ${item.newvalue} email campaign`;
      } else if(item.actiontype === 'evaluation-criteria-updated' && item.action === 'update') {
        actionText = `has updated the evaluation criteria for ${this.projectDetails.projectname}.`
      } else if(item.actiontype == 'bulk-export' && item.action == 'export') {
        const count = item?.additionaldata?.split('-')?.[0];
        const tabname = item?.additionaldata?.split('-')?.[1];
        let tab = '';
        if(tabname === 'shortlisted') {
          tab = 'Shortlisted';
        } else if(tabname === 'archive') {
          tab = 'Archived';
        } else if(tabname === 'unactioned'){
          tab = 'To Review';
        }
        actionText = `has exported ${count} ${tab} candidate${count > 1 ? `'s` : ''}.`;
      } else if(item.actiontype === 'download-pdf' && item.action === 'download'){
        actionText =  item.additionaldata
      } else if (item.actiontype === 'project-details' && (item.action === 'update' && item.updatedfieldname == 'status')) {
        actionText = `has updated the status ${item.newvalue} for ${this.projectDetails.projectname}.`
      } else if (item.actiontype === 'project-details' && (item.action === 'update' && item.updatedfieldname == 'projectname')) {
        actionText = `has updated the Project Name ${item.oldvalue} to ${item.newvalue}.`
      } else if (item.actiontype === 'project-details-edited') {
        actionText = `has updated the Project Details.`
      }
      const user = JSON.parse(item.userdetails || '{}');

      if (actionText?.trim()) {
        formatted.push({
          createdon: item.createdon,
          action: actionText,
          credits: 0,
          firstname: user?.firstname ? user?.firstname : this.userDetails?.firstname,
          lastname: user?.lastname ? user?.lastname : this.userDetails?.lastname,
        });
      }
    }

    const sorted = _.sortBy(formatted, (o: any) => new Date(o.createdon)).reverse();
    const grouped = _.groupBy(sorted, (item: any) => moment(item.createdon).format('YYYY-MM-DD'));
    this.groupedActivityList = [];

    for (const date in grouped) {
      if (grouped.hasOwnProperty(date)) {
        this.groupedActivityList.push({
          date: date,
          displayDate: moment(date).format('MMMM D, YYYY'),
          items: grouped[date]
        });
      }
    }
    this.groupedActivityList.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());
  }

}
